import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";
import { FundReallocationComponent } from "src/app/Account/fund-reallocation/fund-reallocation.component";
import { AddAccountComponent } from "src/app/AddThings/add-account/add-account.component";
import { AddSubtypeComponent } from "src/app/AddThings/add-subtype/add-subtype.component";
import { AddTransactionRequestComponent } from "src/app/AddThings/add-transaction-request/add-transaction-request.component";
import { AddBlacklistCustomerComponent } from "src/app/Blacklist/add-blacklist-customer/add-blacklist-customer.component";
import { EpfRequestCalculatorComponent } from "src/app/LoanRequest/epf-request-calculator/epf-request-calculator.component";
import { SearchTicketComponent } from "src/app/LoanRequest/search-ticket/search-ticket.component";
import { UpdateCommissionMessageComponent } from "src/app/MessageClipboard/update-commission-message/update-commission-message.component";
import { Enums } from "src/app/Shared/enums";
import { SharedService } from "src/app/Shared/shared-service.service";
import { EditProfileComponent } from "src/app/User/edit-profile/edit-profile.component";
import { AddCustomerComponent } from "../../AddThings/add-customer/add-customer.component";
import { AddPlanComponent } from "../../AddThings/add-plan/add-plan.component";
import { AppComponent } from "../../app.component";
import { AuthService } from "../../auth/auth.service";
import { GlobalSearchCustomerComponent } from "../global-search-customer/global-search-customer.component";
import { MaintenanceModeToggleComponent } from "../maintenance-mode-toggle/maintenance-mode-toggle.component";
import { SearchByReceiptComponent } from "../search-by-receipt/search-by-receipt.component";
import { SearchTaskComponent } from "../search-task/search-task.component";
import { ValidateEpfStatementComponent } from "../validate-epf-statement/validate-epf-statement.component";
import { ApplyAssetRequestComponent } from "src/app/AssetRequest/apply-asset-request/apply-asset-request.component";
import { AssetSheetRequestLogComponent } from "src/app/AssetRequest/asset-sheet-request-log/asset-sheet-request-log.component";
import { FinanceAccountListComponent } from "src/app/FinanceAccount/finance-account-list/finance-account-list.component";
declare let $: any;

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  standalone: false,
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  private router = inject(Router);
  private appComponent = inject(AppComponent);
  private _auth = inject(AuthService);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private el = inject(ElementRef);

  @ViewChild("navbar") childRef: ElementRef;
  private resizeObserver!: ResizeObserver;

  title = "theCoolestProject";
  toggled = false;
  key: any;

  loggedInUser: string;
  loggedInRoleID: number;
  loggedInCompanyUid: string;
  loggedInCompanyName: string;

  ngOnInit(): void {
    this.loggedInUser = sessionStorage.getItem("username");
    this.loggedInRoleID = Number(sessionStorage.getItem("roleId"));
    this.loggedInCompanyUid = sessionStorage.getItem("companyUid");
    this.loggedInCompanyName = sessionStorage.getItem("companyName");
  }

  async ngAfterViewInit() {
    // Initialize ResizeObserver to track navbar height changes
    this.resizeObserver = new ResizeObserver(() => {
      const height = this.el.nativeElement.offsetHeight;
      if (this.el.nativeElement)
        document.documentElement.style.setProperty(
          "--navbar-height",
          `${height}px`,
        );
    });
    this.resizeObserver.observe(this.childRef.nativeElement);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  openAddPlanModal() {
    const modalRef = this.sharedService.openModal(AddPlanComponent);
  }
  openAddSubTypeModal() {
    const modalRef = this.sharedService.openModal(AddSubtypeComponent);
  }

  openAddCustomerModal() {
    const modalRef = this.sharedService.openModal(
      AddCustomerComponent,
      "largeModal",
    );
    //get customer that was created
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });
  }

  openAssetSheetLog() {
    const modalRef = this.sharedService.openModal(
      AssetSheetRequestLogComponent,
      "largeModal",
    );
  }

  openEPFCalculatorModal() {
    const modalRef = this.sharedService.openModal(
      EpfRequestCalculatorComponent,
    );
    modalRef.componentInstance.epfLimitRuleSet = this.enums.epfLimitList;
  }

  openEditProfileModal() {
    const modalRef = this.sharedService.openModal(EditProfileComponent);
  }

  openAddAccountModal() {
    const modalRef = this.sharedService.openModal(AddAccountComponent);
  }

  //ASSET REQUEST MODALS
  openAddApplyExpensesModal() {
    const modalRef = this.sharedService.openModal(
      ApplyAssetRequestComponent,
      "largeModal",
    );
    modalRef.componentInstance.type = "Apply";
  }

  openAddReturnCashRequestModal() {
    const modalRef = this.sharedService.openModal(
      ApplyAssetRequestComponent,
      "largeModal",
    );
    modalRef.componentInstance.type = "Return";
  }

  openGlobalSearchModal(isGlobal: boolean) {
    const modalRef = this.sharedService.openModal(
      GlobalSearchCustomerComponent,
      "largeModal",
    );
    // const modalRef = this.sharedService.openModal(GlobalSearchCustomerComponent, { windowClass: "largeModal" });
    modalRef.componentInstance.isGlobal = isGlobal;
  }

  openSearchTaskModal() {
    const modalRef = this.sharedService.openModal(
      SearchTaskComponent,
      "largeModal",
    );
  }

  openSearchCustomerByReceiptModal() {
    const modalRef = this.sharedService.openModal(
      SearchByReceiptComponent,
      "largeModal",
    );
  }

  openFundAllocationModal() {
    const modalRef = this.sharedService.openModal(
      FundReallocationComponent,
      "largeModal",
    );
  }
  openMaintenaceModeModal(On: boolean) {
    const modalRef = this.sharedService.openModal(
      MaintenanceModeToggleComponent,
      "largeModal",
    );
    modalRef.componentInstance.turn_on = On;
  }

  openAddTransactionRequestModal() {
    const modalRef = this.sharedService.openModal(
      AddTransactionRequestComponent,
      "largeModal",
    );
  }

  openAddBlacklistCustomer() {
    const modalRef = this.sharedService.openModal(
      AddBlacklistCustomerComponent,
    );
  }

  openValidateEPFStatement() {
    const modalRef = this.sharedService.openModal(
      ValidateEpfStatementComponent,
    );
  }

  openSearchTicketModal() {
    const modalRef = this.sharedService.openModal(
      SearchTicketComponent,
      "largeModal",
    );
  }

  openEditCommissionModal() {
    const modalRef = this.sharedService.openModal(
      UpdateCommissionMessageComponent,
      "largeModal",
    );
  }

  goToBookmarks() {
    this.router.navigate(["/bookmarks"]);
  }

  goToServerStatusPage() {
    this.router.navigate(["/serverStatus"]);
  }

  goToAuthLogPage() {
    this.router.navigate(["/authLog"]);
  }

  toggleMenu() {
    $("#sidebar").toggleClass("active");
  }

  toggleSidebar() {
    this.appComponent.toggleSidebar();
  }

  logout() {
    this._auth.logout();
  }
}
